import { combineReducers } from 'redux'

import tripsReducer from './data/trips/reducer'
// import ordersReducer from './data/orders/reducer'
import landingPageReducer from './scenes/LandingPage/reducer'
import reservationsPageReducer from './scenes/ReservationsPage/reducer'
import customerInfoFormReducer from './scenes/ReviewOrder/CustomerInfoForm/reducer'
// import customerInfoPageReducer from './scenes/CustomerInfoPage/reducer'
// import searchResultsPageReducer from './scenes/SearchResultsPage/reducer'
import { reducer as reduxFormReducer } from 'redux-form'

const appReducer = combineReducers({
  landingPage: landingPageReducer,
  customerInfoForm: customerInfoFormReducer,
  reservationPage: reservationsPageReducer,
  // customerInfoPage: customerInfoPageReducer,
  // searchResults: searchResultsPageReducer,
  trips: tripsReducer,
  // orders: ordersReducer,
  form: reduxFormReducer // mounted under "form"
});

const rootReducer = (state, action) => {
  // Resets Redux store to the default/initial state because
  // reducers are supposed to return the initial state when they are called with undefined
  // https://stackoverflow.com/a/35641992/2213882
  // So with the below, we teach the rootReducer how to return the initial state.
  if (action.type === 'RESET_STATE') {
    
    // This sets everything previously in state to undefined, except state.form from redux-form
    const { form } = state;
    state = { form };
    // if state.form is deleted manually above, redux-form malfunctions e.g. validations don't work
    // To reset redux-form values, they are cleared on an individual basis, by calling props.reset() in connected props
    // e.g. in landingPageForm we have componentDidMount() { this.props.reset() }   
    // https://redux-form.com/6.5.0/docs/api/props.md/#-reset-function-
  }


  return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers.js